import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';

const createRootReducer = () =>
  combineReducers({
    oidc: oidcReducer,
  });

export default createRootReducer;
